/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import { Box } from 'native-base';
import { useOffersScreen, useSpringBigStore } from '@springbig/shared';
import Section from '~/shared/Section';
import RedeemedRewardModal from '~/shared/RedeemedReward';
import { useAuthorization } from '~/hooks/auth';
import OffersCard, { OffersCardSkeleton } from './components/OfferCard';
import ExtensionDetailsModal from '~/shared/ExtensionDetailsModal';
import Button from '~/shared/Button';
import { useGeneralStyles } from '~/shared/styles';
import { useAppNavigate } from '~/pages';
import SuspendedMerchantScreen from '~/shared/SuspendedMerchantScreen';
import { NoDataPlaceholder } from '~/shared/NoDataPlaceholder';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import { Caption } from '~/shared/Typography';
import ConditionalForm, { AutoConnectFieldType } from './components/MemberForm';

const OffersScreen = () => {

    const {
        rewardGrants,
        successRedeem,
        rewardActiveId,
        loadingActivation,
        onRefresh,
        handleAcceptRedeemReward,
        handleCancelRedeem,
        handleAcceptRedeem,
        handleBonusRewards,
        t,
        member,
        showAlert,
        setShowAlert,
        isLoading,
        setSuccessRedeem,
        desiredActions,
        redeemOfferInStore
    } = useOffersScreen();

    const gStyles = useGeneralStyles();
    const { navigate, params } = useAppNavigate();
    const { id } = params || {};

    const { walletId } = useSpringBigStore();
    const [showConditionalForm, setShowConditionalForm] = useState<boolean>(false);
    const [selectedTypeId, setSelectedTypeId] = useState<AutoConnectFieldType>(0);
    
    useEffect(() => {

        if (id) {
            const int = Number(id);

            if (!isNaN(int)) {
                setTimeout(() => {

                    setShowAlert({ status: true, id: int, title: null });
                }, 1000);
            }
        }
    }, [id]);


    const { isLoadingAuth } = useAuthorization();

    if ((!rewardGrants || !rewardGrants.length) && (!desiredActions || !(desiredActions && desiredActions.length)) && !isLoading) {
        return (<NoDataPlaceholder
            title={t('common.offers_placeholder_title')}
            message={t('common.offers_placeholder_subtitle')}
            callback={onRefresh}
            isLoading={isLoading}
            iconName={faGift}
        />);
    }

    const handleModalClose = (): void => {

        handleCancelRedeem();
    };

    const onGetOffer = (typeId : number) => {

        switch (typeId) {
            case 8:
                setSelectedTypeId(8);
                setShowConditionalForm(true);
                return;
            case 10:
                setSelectedTypeId(10);
                setShowConditionalForm(true);
                return;
            case 9:
                navigate(`w/${walletId}/profile/interests`, { state: { isInterestScreen: true } });
                return;
        }
    };


    return (
        <Section
            flex={1}
            w={'100%'}
            overflowY={'auto'}
            overflowX={'hidden'}
            pageHeaderChildren={
                member && member.referrals.active && <Button
                    bg={gStyles.button_background}
                    _text={{
                        color: gStyles.button_text,
                    }}
                    onPress={() => navigate(`w/${params.wallet_id}/refer`)}
                >
                    {t('offers.refer_friend')}
                </Button>
            }
        >
            <Box alignItems={'center'}>
                {(isLoading || isLoadingAuth) ? <OffersCardSkeleton /> :
                    <>
                        {desiredActions && 
                            <OffersCard 
                                desiredActions={desiredActions as any}
                                onGetOffer={onGetOffer}
                                isLoading={isLoading}
                            />
                        }
                        <OffersCard
                            rewardGrants={rewardGrants}
                            handleAcceptRedeemReward={handleAcceptRedeemReward}
                            handleBonusRewards={handleBonusRewards}
                            rewardActiveId={rewardActiveId}
                            loadingActivation={loadingActivation}
                            isLoading={isLoading}
                        /></>}
            </Box>

            {member && member.show_pending_modal &&
                <SuspendedMerchantScreen />
            }

            {showAlert.id &&
                (
                    <ExtensionDetailsModal
                        showModal={showAlert.status}
                        extensionId={showAlert.id}
                        type={'offers'}
                        onCloseModal={handleModalClose}
                        onRedeem={handleAcceptRedeem}
                        isInStore={redeemOfferInStore}
                    />)
            }
            {
                successRedeem && (
                    <RedeemedRewardModal
                        memberPhoneNumber={member?.phone_number || ''}
                        createdAt={successRedeem.created_at}
                        confirmationNumber={successRedeem.id}
                        returnWallet={() => setSuccessRedeem(null)}
                        isOpen={true}
                        image={successRedeem.reward.images}
                        expires={successRedeem.expires}
                        description={successRedeem.reward.description || ''}
                        title={successRedeem.reward.item_name}
                    />
                )
            }

            {showConditionalForm &&
                <ConditionalForm
                    isOpen={showConditionalForm}
                    closeModal={() => setShowConditionalForm(false)}
                    fieldType={selectedTypeId}
                />
            }
        </Section>
    );
};

export default OffersScreen;
